import { render, staticRenderFns } from "./TablePagePersone.vue?vue&type=template&id=f4c2b0da"
import script from "./TablePagePersone.vue?vue&type=script&lang=js"
export * from "./TablePagePersone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports